import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fixPer'
})
export class FixPerPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value
      .replace(/(\w+)per\b/gi, (_, prefix) => `${prefix} Per`).replace(/([a-zA-Z])(\d)/g, '$1 $2').replace(/\s+/g, ' ')
      .trim();
  }
}
